
import { supabase } from '@/integrations/supabase/client';
import { ParentChildRelationship, FanTeam } from '@/types/database';

export const relationshipService = {
  // Parent-Child relationships
  async getParentChildren(parentId: string): Promise<ParentChildRelationship[]> {
    const { data, error } = await supabase
      .from('parent_child_relationships')
      .select('*')
      .eq('parent_user_id', parentId);
    
    if (error) throw error;
    return data || [];
  },

  async addParentChildRelationship(parentId: string, childId: string): Promise<ParentChildRelationship> {
    const { data, error } = await supabase
      .from('parent_child_relationships')
      .insert({
        parent_user_id: parentId,
        child_user_id: childId
      })
      .select()
      .single();
    
    if (error) throw error;
    return data;
  },

  // Fan relationships
  async getFanTeams(fanId: string): Promise<FanTeam[]> {
    const { data, error } = await supabase
      .from('fan_teams')
      .select(`
        *,
        team:teams(*)
      `)
      .eq('fan_id', fanId);
    
    if (error) throw error;
    return data || [];
  },

  async addFanTeam(fanId: string, teamId: number): Promise<FanTeam> {
    const { data, error } = await supabase
      .from('fan_teams')
      .insert({
        fan_id: fanId,
        team_id: teamId
      })
      .select()
      .single();
    
    if (error) throw error;
    return data;
  },

  async removeFanTeam(fanId: string, teamId: number): Promise<void> {
    const { error } = await supabase
      .from('fan_teams')
      .delete()
      .eq('fan_id', fanId)
      .eq('team_id', teamId);
    
    if (error) throw error;
  },

  // Coach-Player relationships
  async getCoachPlayers(coachId: string): Promise<any[]> {
    const { data, error } = await supabase
      .from('profiles')
      .select('*')
      .eq('coach_id', coachId);
    
    if (error) throw error;
    return data || [];
  },

  async assignPlayerToCoach(playerId: string, coachId: string): Promise<void> {
    const { error } = await supabase
      .from('profiles')
      .update({ coach_id: coachId })
      .eq('id', playerId);
    
    if (error) throw error;
  }
};
